import { Link } from "react-router-dom";
import "pages/common.scss";

export const UnsubscribedPage = (): JSX.Element => {
  return (
    <div className="wide page">
      <h2>Unsubscribed</h2>
      <p>So long!</p>
      <p>You will no longer receive any email from us, except for password recovery.</p>
      <p>If you unsubscribed by mistake, you can revert this on the <Link to="/settings/account">settings</Link> page.</p>
    </div>
  );
};

export default UnsubscribedPage;
